import http from './http-service'
import config from '../config/constant'

const viewToken = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'CARDLESSVIEWTOK',
      module: 'CARDLESSCASHOUT',

    }
    const response = await http.post(config.cardLessCash.viewToken, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const initVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'INITIATECARDLESSCASHOUT',
      module: 'CARDLESSCASHOUT',
    }
    const response = await http.post(config.cardLessCash.initVerify, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const initConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'APPOVECARDLESSCASHOUT',
    }
    const response = await http.post(config.cardLessCash.initConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const deleteToken = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'CARDLESSCANCELTOK',
      module: 'CARDLESSCASHOUT',
    }
    const response = await http.post(config.cardLessCash.delete, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const cancelToken = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'CARDLESSCANCELTOK',
      module: 'CARDLESSCASHOUT',
    }
    const response = await http.post(config.cardLessCash.cancel, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const CardLessService = {
  viewToken,
  deleteToken,
  initVerify,
  initConfirm,
  cancelToken,
}

export default CardLessService
